'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _themePredictiveSearch = require('@shopify/theme-predictive-search');

var _themePredictiveSearch2 = _interopRequireDefault(_themePredictiveSearch);

var _themePredictiveSearchComponent = require('@shopify/theme-predictive-search-component');

var _themePredictiveSearchComponent2 = _interopRequireDefault(_themePredictiveSearchComponent);

var _functional = require('../utils/functional');

var _tracking = require('../utils/tracking');

var _helpers = require('./_helpers');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var els = {
    el: el,
    triggers: (0, _functional.getElements)('.' + context.className + '_Trigger'),
    form: context.getElement('.' + context.className + '_Form'),
    input: (0, _functional.getElement)('.' + context.className + '_Input'),
    reset: (0, _functional.getElement)('#reset'),
    result: (0, _functional.getElement)('#result')
  };

  var predictiveSearch = new _themePredictiveSearchComponent2.default({
    PredictiveSearchAPIConfig: {
      resources: {
        type: [_themePredictiveSearch2.default.TYPES.PRODUCT],
        options: {
          fields: [_themePredictiveSearch2.default.FIELDS.TITLE, _themePredictiveSearch2.default.FIELDS.VENDOR, _themePredictiveSearch2.default.FIELDS.PRODUCT_TYPE, _themePredictiveSearch2.default.FIELDS.VARIANTS_TITLE]
        }
      }
    },
    selectors: {
      input: '.' + context.className + '_Input',
      reset: '.' + context.className + '_Reset',
      result: '.' + context.className + '_Result'
    },
    resultTemplateFct: function resultTemplateFct(data) {
      var products = data.products || [];

      return '\n        <div class="sea-Results">\n          <ul class="sea-Results_List">\n            ' + products.map(function (product) {
        return '\n                <li class="sea-Results_Item" data-search-result>\n                  <a class="sea-Result" href="' + product.url + '">\n                    <div class="sea-Result_ImageContainer">\n                      <img src="' + product.image + '" alt="' + product.title + '" class="sea-Result_Image"/>\n                    </div>\n                    <span class="sea-Result_Text">' + product.title + '</span>\n                  </a>\n                </li>\n              ';
      }).join('') + '\n          </ul>\n        </div>\n    ';
    },
    // (a11y) Function to return the number of results that you will display.
    // This will be announced to the user via an aria-live.
    numberOfResultsTemplateFct: function numberOfResultsTemplateFct(data) {
      if (data.products.length === 1) {
        return 'one result found';
      } else {
        return '[results_count] results found'.replace('[results_count]', data.products.length);
      }
    },
    // (a11y) Return a string that indicates that we're loading results.
    // This will be announced to the user via an aria-live.
    loadingResultsMessageTemplateFct: function loadingResultsMessageTemplateFct() {
      return 'loading';
    },
    onInputReset: function onInputReset(a, b, c) {
      window.predictiveSearch.clearAndClose();
    }
  });

  var closeOnClickOutside = {
    trigger: null,
    dispatch: function dispatch(e) {
      if (!e.target.closest('.' + context.className + '_Trigger') && !e.target.closest('.' + context.className + '_Form')) {
        toggleOpenClose(null, closeOnClickOutside.trigger);
      }
    }
  };

  var toggleOpenClose = function toggleOpenClose(e, trigger) {
    window.theme.searchBar.isActive = !window.theme.searchBar.isActive;

    var event = new CustomEvent(_helpers.EVENT_NAMES.SEARCH_TRIGGER_CLICK, {
      bubbles: true
    });

    els.el.classList.toggle('hd-Header_Search-active', window.theme.searchBar.isActive);

    els.input.focus();

    trigger.dispatchEvent(event);

    if (!window.theme.searchBar.isActive) {
      predictiveSearch.clearAndClose();
    }

    if (trigger) {
      closeOnClickOutside.trigger = trigger;
    }

    if (window.theme.searchBar.isActive) {
      window.addEventListener('click', closeOnClickOutside.dispatch);
    } else {
      window.removeEventListener('click', closeOnClickOutside.dispatch);
    }

    // We need to hide any drawer that is opened, but only when user
    // has interacted with trigger
    if (e && e.isTrusted) {
      window.drawers.activeDrawerKey = '';
    }
  };

  if (els.triggers) {
    els.triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        return toggleOpenClose(e, trigger);
      });
    });
  }

  els.input.addEventListener('search', function (e) {
    if (e.target.value === '') {
      predictiveSearch.clearAndClose();
    }
  });

  els.form.addEventListener('submit', function (e) {
    var formData = new FormData(els.form);

    if (window.theme.isBHPreview) {
      var eventSearch = new Event('search');
      eventSearch.payload = {
        search_term: formData.get('q')
      };
      document.dispatchEvent(eventSearch);
    } else {
      (0, _tracking.trackGtag)({
        eventCategory: 'Main Navigation',
        eventAction: 'Search',
        eventLabel: formData.get('q')
      });
    }
  });
}